// Centralized site configuration. Update logos, contact details, brand here.
export const SITE = {
  logoUrl: "https://customer-assets.emergentagent.com/job_5f7d5117-b23f-49b7-978b-fc0083a0bb69/artifacts/ir8c0nrz_eah.jpg",
  brand: {
    en: "ELITE AL HIJAZ Est.",
    ar: "مؤسسة نخبة الحجاز للمقاولات",
    short: "EAH",
  },
  contact: {
    // Update these to change contact info site-wide
    phones: ["+966 50 847 7469", "+966 56 399 2654", "+966 12 669 0862"],
    emails: ["admin@elitealhijaz.com", "gafoor@elitealhijaz.com", "irfan@elitealhijaz.com"],
    whatsapp: "966508477469", // primary number for wa.me
    primaryEmail: "admin@elitealhijaz.com",
    address: {
      en: "Wadi Al Qaim Street, Al Aziziyah Dist, Jeddah 23337, Kingdom of Saudi Arabia",
      ar: "شارع وادي القائم، حي العزيزية، جدة 23337، المملكة العربية السعودية",
    },
    website: "www.elitealhijaz.com",
    cr: "4030136096",
    vat: "300887663500003",
    // Google Maps embed URL — replace 'q' parameter to update location
    mapsEmbed:
      "https://www.google.com/maps?q=Al%20Aziziyah%20District%2C%20Jeddah%2023337%2C%20Saudi%20Arabia&output=embed",
  },
};

// Industrial stock images (Unsplash / Pexels). Replace to taste — keep ratios similar.
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1763405739542-02991ab5416c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroOverlay: "https://images.unsplash.com/photo-1664022447173-062a8edb226a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  about: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1600&q=80",
  fabrication: "https://images.unsplash.com/photo-1586333109867-812586269a58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  automation: "https://images.unsplash.com/photo-1759159091682-3b98f4759367?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  electrical: "https://images.unsplash.com/photo-1581093458791-9d09c5e34386?auto=format&fit=crop&w=1600&q=80",
  maintenance: "https://images.unsplash.com/photo-1581092335203-04b27e8b9e63?auto=format&fit=crop&w=1600&q=80",
  manpower: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=1600&q=80",
  contact: "https://images.unsplash.com/photo-1565514020179-026b92b84bb6?auto=format&fit=crop&w=1600&q=80",
  projects: [
    "https://images.pexels.com/photos/4561617/pexels-photo-4561617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.pexels.com/photos/32529354/pexels-photo-32529354.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.unsplash.com/photo-1664022447173-062a8edb226a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.pexels.com/photos/1108572/pexels-photo-1108572.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.pexels.com/photos/3862627/pexels-photo-3862627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    "https://images.pexels.com/photos/2760241/pexels-photo-2760241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  ],
};
